import { render, staticRenderFns } from "./activation_step_two_modification.vue?vue&type=template&id=6a42471e&scoped=true&"
import script from "./activation_step_two_modification.vue?vue&type=script&lang=js&"
export * from "./activation_step_two_modification.vue?vue&type=script&lang=js&"
import style0 from "./activation_step_two_modification.vue?vue&type=style&index=0&id=6a42471e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a42471e",
  null
  
)

export default component.exports